import {ConfigStructure} from './config-structure.model';

export class GroupedConfigStructure{

  elements: ConfigStructure[] = [];

  row: boolean;

  mobileLimit = false;

  constructor(element: ConfigStructure) {
    this.elements.push(element);
    this.row = !element.skipNewLine;
  }

  append(element: ConfigStructure){
    this.elements.push(element);
  }
}
